export async function uploadErrorMessage(response: Response): Promise<string> {
  try {
    const body = await response.json();
    if (typeof body?.message === 'string' && body.message.trim()) return body.message;
  } catch { /* Proxies may return HTML instead of JSON. */ }
  if (response.status === 413) return 'Image is too large — uploads are capped at 25MB.';
  return 'Could not upload image. Please try again.';
}
